/*
 * @Author: 李文 
 * @Date: 2020-10-31 10:57:56 
 * @Last Modified by: 李文
 * 微信发布 创建选题
 */
import React from 'react';
import { Modal, Button, message } from 'antd';
import { TopicSelectionListFormModal } from '../../../components/topicSelection/topicSelectionList';
import { connect } from 'react-redux';
import { getPmsUser, editTopicSelection, addTopicSelection  } from '../../../actions/topicSelection';
import NewsActivityComplete from '../../../containers/newsActivity/NewsActivityComplete';
import './index.scss';

class AddTopic extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            visible: false,
            data: { tsCreateBy: this.props.currentUser?[this.props.currentUser.account]:[]},
            tsCreateBy: '',
            step: 1,
        }
    }

    componentWillMount(){
        getPmsUser().then(dto=>{
            this.pmsUser = dto.data;
        });
    }

    changeVisible = (visible) => {
        this.setState({
            visible,
            step: 1,
            tsCreateBy: '',
            data:{ tsCreateBy: this.props.currentUser?[this.props.currentUser.account]:[]}
        })
    }

    tsCreateByChange = (tsCreateBy) =>{
        this.setState({
            tsCreateBy
        })
    }

    handleCancel = () => {
        this.changeVisible(false)
    }

    save = (tsStatus) => {
      
        let errorsInfo=[];
        this.listRef.props.form.validateFields((errors,values)=>{
            errorsInfo=errors;
        });

        if(errorsInfo){
            for(let i in errorsInfo){
                message.error(errorsInfo[i].errors[0].message,1);
                return false;
            }
        }
        let tsFileIds = [];
        for(let i = 0 ; this.listRef.state.fileList && i < this.listRef.state.fileList.length; i++){
            let file = this.listRef.state.fileList[i];
            if(file.resourceId){
                tsFileIds.push(file.resourceId);
            }
        }
        let userName =window.top.currentUser.name;

        let userAccount =window.top.currentUser.account

         let topicSelection = this.listRef.props.form.getFieldsValue();
        topicSelection.tsFileIds = tsFileIds;

        topicSelection.tsAppointee =  [userAccount] ;
        topicSelection.tsAppointeeName =[userName];
        //topicSelection.id = this.state.topicSelection.id;  
        topicSelection.tsCreateBy = this.state.data.tsCreateBy;
        if(tsStatus){
            topicSelection.tsStatus = tsStatus;
        }else if(this.state.topicSelection.tsStatus){
            topicSelection.tsStatus = this.state.data.tsStatus;
        }
        window.loading.show();   
        addTopicSelection(topicSelection).then(res=>{
            window.loading.hide();
            //message.success("添加成功");
            this.setState({
                step: 2,
                data: res.data
            })
        })
    }
    
    relateWrite = () => {
        this.props.callBack && this.props.callBack(this.state.data);
        this.handleCancel();
    }

    renderContent = (type) => {
        const { data }  = this.state;
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        if(type === 1){
            return(
                <>
                    <TopicSelectionListFormModal
                        data={data}
                        pmsUser={this.pmsUser}
                        sysConfig={this.props.sysConfig}
                        // currentUser = {currentUser}
                        tsCreateByChange={(tsCreateBy) => this.tsCreateByChange(tsCreateBy)}
                        wrappedComponentRef={(inst) => this.listRef = inst}
                    />
                    <div className="bottom">
                        <Button onClick={this.handleCancel}>关闭</Button>
                        <Button type="primary"  onClick={() => { this.save(2) }}>提交选题</Button>
                    </div>
                </>
            )  
        } else {
            return (
                <>
                    <NewsActivityComplete type="选题管理" topicSelectionData={{topicSelection: this.state.data}}/>
                    <div className="bottom">
                        <Button onClick={this.handleCancel}>关闭</Button>
                        {this.props.relateWriteVisible?<Button type="primary"  onClick={this.relateWrite}>关联写作</Button>:null}
                    </div>
                </>
            )
        }
    }

    render(){
        const { visible, step } = this.state;
        const { currentUser } = this.props;
        return (
            <Modal
                title="新增选题"
                className="add-topic-modal"
                width={800}
                visible={visible}
                maskClosable={false}   //点击蒙层是否允许关闭
                onCancel={this.handleCancel}
                footer={null}
                destroyOnClose={true}
            >
                <div className="wrap">
                    {this.renderContent(step)}
                </div>
            </Modal>
        )
    }
}

AddTopic.defaultProps = {
    relateWriteVisible: true
}

const mapStateToProps = (state) => {
    return{
        currentUser: state.systemReducer.currentUser,
        config : state.systemReducer.config
    }
}

export default connect(mapStateToProps, null, null, {forwardRef  : true})(AddTopic)